import { LatLngExpression } from 'leaflet';

export interface State {
	boundaryOutline: any;
	center: LatLngExpression;
	heatmap: any[];
	infinite: boolean;
	maxZoom: number;
	minZoom: number;
	noWrap: boolean;
	scrollWheelZoom: boolean;
	wheelPxPerZoomLevel: number;
	zoom: number;
	zoomDelta: number;
	zooming: boolean;
	zoomProjectionMargin: number;
	zoomSnap: number;
}

export const stateFactory = (boundaryOutline: any[] = [], heatmap: any[] = []): State => {
	return {
		boundaryOutline: boundaryOutline,
		center: [0.0, 0.0],
		heatmap: heatmap,
		infinite: false,
		maxZoom: 5,
		minZoom: 0,
		noWrap: true,
		scrollWheelZoom: false,
		wheelPxPerZoomLevel: 120,
		zoom: 1,
		zoomDelta: 0.1,
		zooming: false,
		zoomProjectionMargin: 1,
		zoomSnap: 0.1,
	};
};
